"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./icon"));
__export(require("./icon-picker.component"));
__export(require("./icon-picker.directive"));
__export(require("./icon-picker.module"));
__export(require("./icon-picker.service"));



//////////////////
// WEBPACK FOOTER
// ./src/lib/index.ts
// module id = 5
// module chunks = 0 1